import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import { takeUntil } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { NgScrollbar } from 'ngx-scrollbar';
import { commitmentsActions } from '../../../store/commitments/commitments.actions';
import { commitmentsSelectors } from '../../../store/commitments/commitments.selectors';
import { COMMITMENTS_INTERACTION_BAR_TYPE } from '../../constants/interaction-bar.constants';
import { FadedTextComponent } from '../../faded-text/faded-text.component';
import { MoneyPipe } from '../../../pipes/framework/money-short.pipe';
import {
  InvoiceCost,
  ContractSummaryCommitmentItem,
  ContractSummaryCommitmentItemCost,
} from '@app/store/commitments/contract-summary.commitments.types';

@Component({
  selector: 'app-cost-view-table-dropdown',
  templateUrl: './cost-view-table-dropdown.component.html',
  styleUrls: ['./cost-view-table-dropdown.component.scss'],
  imports: [CommonModule, NgScrollbar, FadedTextComponent, MoneyPipe],
})
export class CostViewTableDropdownComponent implements AfterViewInit, OnDestroy {
  costs: InvoiceCost[] = [];
  commitmentItems: ContractSummaryCommitmentItem[] = [];
  COMMITMENTS_INTERACTION_BAR_TYPE = COMMITMENTS_INTERACTION_BAR_TYPE;

  @Input() commitmentType: COMMITMENTS_INTERACTION_BAR_TYPE;
  @Input() costIndex: number;
  @Input() spendEntryIndex: number;
  @Input() disableDelete = false;
  @Input() disableAdd = false;

  @Output() closeMe = new EventEmitter();

  isDestroyed$ = new Subject();

  constructor(private store: Store) {}

  ngAfterViewInit(): void {
    if (this.commitmentType === COMMITMENTS_INTERACTION_BAR_TYPE.INVOICES) {
      this.store
        .select(commitmentsSelectors.getSelectableInvoiceCosts)
        .pipe(takeUntil(this.isDestroyed$))
        .subscribe((results) => {
          this.costs = results;
        });
    }

    this.store
      .select(commitmentsSelectors.getSelectableLineItemsForChangeOrder(this.spendEntryIndex))
      .pipe(takeUntil(this.isDestroyed$))
      .subscribe((results) => {
        this.commitmentItems = results;
      });
  }

  selectInvoiceCost(cost: InvoiceCost) {
    if (this.commitmentType === COMMITMENTS_INTERACTION_BAR_TYPE.INVOICES) {
      this.store.dispatch(
        commitmentsActions.selectInvoiceCost({
          costIndex: this.costIndex,
          cost: { ...cost },
        }),
      );

      this.closeMe.emit(true);
    }
  }

  selectCost(cost: Partial<ContractSummaryCommitmentItemCost>) {
    if (!cost) {
      console.warn('No cost selected');
      return;
    }
    this.store.dispatch(
      commitmentsActions.selectChangeOrderSpendEntryCost({
        spendEntryIndex: this.spendEntryIndex,
        costIndex: this.costIndex,
        cost: { ...cost, is_dropdown: true, value: null },
      }),
    );

    this.closeMe.emit(true);
  }

  ngOnDestroy() {
    this.isDestroyed$.next(true);
    this.isDestroyed$.complete();
  }
}
